import { render, staticRenderFns } from "./FilesCard.vue?vue&type=template&id=86ea1ec6"
import script from "./FilesCard.vue?vue&type=script&lang=ts"
export * from "./FilesCard.vue?vue&type=script&lang=ts"
import style0 from "./FilesCard.vue?vue&type=style&index=0&id=86ea1ec6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports